(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poski-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  // POSKI Breadcrumbs – merkt sich die zuletzt besuchte Kollektion (nur im Browser
  // der Kundin, sessionStorage) und zeigt auf der Produktseite den echten Klickweg.
  // Der für Google hinterlegte Pfad (JSON-LD) bleibt davon unberührt.
  (function () {
    var KEY = 'poski:lastCollection';

    function init(nav) {
      if (nav.dataset.poskiBcInit === '1') return;
      nav.dataset.poskiBcInit = '1';

      // Auf Kollektionsseiten: Kollektion für den weiteren Weg merken
      if (nav.dataset.pageType === 'collection') {
        if (!nav.dataset.collectionHandle) return;
        try {
          sessionStorage.setItem(
            KEY,
            JSON.stringify({
              handle: nav.dataset.collectionHandle,
              title: nav.dataset.collectionTitle,
              url: nav.dataset.collectionUrl,
            })
          );
        } catch (e) {
          /* sessionStorage gesperrt (z.B. Inkognito-Sonderfälle) – dann bleibt der Fallback-Pfad */
        }
        return;
      }

      if (nav.dataset.pageType !== 'product') return;
      if (nav.dataset.showCollection !== 'true') return;

      var last = null;
      try {
        last = JSON.parse(sessionStorage.getItem(KEY));
      } catch (e) {
        return;
      }
      if (!last || !last.handle || !last.title || !last.url) return;

      // Nur tauschen, wenn das Produkt wirklich in dieser Kollektion ist
      var handles = (nav.dataset.productCollections || '').split(',');
      if (handles.indexOf(last.handle) === -1) return;

      var link = nav.querySelector('[data-poski-bc-collection]');
      if (link) {
        if (link.dataset.handle === last.handle) return;
        link.textContent = last.title;
        link.href = last.url;
        link.dataset.handle = last.handle;
      } else {
        // Kein Kollektions-Glied gerendert (z.B. alle ignoriert) → eines einfügen.
        // Vor dem Produktnamen einfügen, falls der angezeigt wird — sonst ans Ende.
        var list = nav.querySelector('.poski-breadcrumbs__list');
        if (!list) return;
        var currentEl = list.querySelector('.poski-breadcrumbs__current');
        var beforeItem = currentEl ? currentEl.closest('li') : null;
        var li = document.createElement('li');
        li.className = 'poski-breadcrumbs__item';
        var sep = document.createElement('span');
        sep.className = 'poski-breadcrumbs__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = nav.dataset.separator || '›';
        var a = document.createElement('a');
        a.className = 'poski-breadcrumbs__link';
        a.href = last.url;
        a.textContent = last.title;
        li.appendChild(sep);
        li.appendChild(a);
        if (beforeItem) {
          list.insertBefore(li, beforeItem);
        } else {
          list.appendChild(li);
        }
      }
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-poski-bc]').forEach(init);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poski-inspiration-board"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBoard(root) {
      if (!root || root.dataset.poskiIbInit === 'true') return;
      root.dataset.poskiIbInit = 'true';

      var sentinel = root.querySelector('[data-poski-ib-sentinel]');
      var currentBatch = 0;
      var observer;

      function revealNextBatch() {
        currentBatch += 1;
        var next = root.querySelectorAll('[data-poski-ib-pin][data-batch="' + currentBatch + '"]');

        if (!next.length) {
          if (observer) observer.disconnect();
          return;
        }

        next.forEach(function (pin) {
          pin.removeAttribute('hidden');
        });

        var remaining = root.querySelectorAll('[data-poski-ib-pin][hidden]');
        if (!remaining.length && observer) observer.disconnect();
      }

      if (sentinel) {
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) revealNextBatch();
              });
            },
            { rootMargin: '600px 0px' }
          );
          observer.observe(sentinel);
        } else {
          root.querySelectorAll('[data-poski-ib-pin][hidden]').forEach(function (pin) {
            pin.removeAttribute('hidden');
          });
        }
      }

      var lastTrigger = null;

      root.querySelectorAll('[data-poski-ib-pin]').forEach(function (pin) {
        pin.addEventListener('click', function () {
          var dialog = document.getElementById(pin.getAttribute('aria-controls'));
          if (!dialog) return;

          lastTrigger = pin;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      });

      root.querySelectorAll('[data-poski-ib-modal]').forEach(function (dialog) {
        var closeBtn = dialog.querySelector('[data-poski-ib-close]');

        function closeDialog() {
          dialog.close();
        }

        if (closeBtn) closeBtn.addEventListener('click', closeDialog);

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener('close', function () {
          if (lastTrigger) {
            lastTrigger.focus();
            lastTrigger = null;
          }
        });
      });

      root.querySelectorAll('[data-poski-ib-variant-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          var row = select.closest('.poski-inspiration-board__product-row');
          if (!row) return;

          var option = select.selectedOptions[0];
          if (!option) return;

          var variantIdInput = row.closest('form')?.querySelector('input[name="id"]');
          if (variantIdInput) variantIdInput.value = option.value;

          var priceEl = row.querySelector('[data-poski-ib-price]');
          if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

          var addButton = row.querySelector('button[type="submit"]');
          if (addButton) addButton.disabled = option.dataset.available === 'false';
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-poski-inspiration-board]').forEach(initBoard);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-poski-inspiration-board]').forEach(initBoard);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poski-spotted-on-you"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpotted(root) {
      var track = root.querySelector('[data-poski-track]');
      if (!track || root.dataset.poskiInit === 'true') return;
      root.dataset.poskiInit = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-poski-item]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-poski-dot]'));
      var prevBtn = root.querySelector('[data-poski-prev]');
      var nextBtn = root.querySelector('[data-poski-next]');

      function activeIndex() {
        var nearest = 0;
        var min = Infinity;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - track.scrollLeft - track.clientLeft);
          if (dist < min) {
            min = dist;
            nearest = i;
          }
        });
        return nearest;
      }

      function updateUI() {
        var idx = activeIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) {
          nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }

      function scrollByPage(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-poski-dot'), 10);
          if (items[i]) {
            track.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
          }
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateUI();
          ticking = false;
        });
      });

      window.addEventListener('resize', updateUI);
      updateUI();
    }

    function initAll() {
      document.querySelectorAll('[data-poski-spotted]').forEach(initSpotted);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-poski-spotted]').forEach(initSpotted);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
